const columns = [
  {
    Header: '#',
    id: 'rowIndex',
    Cell: ({ row, state }) => {
      const pageIndex = state?.pageIndex ?? 0;
      const pageSize = state?.pageSize ?? 15;
      return pageIndex * pageSize + row.index + 1;
    },
    disableSortBy: true
  },
  {
    Header: 'Site Name',
    id: 'displayName',
    type: 'string',
    accessor: site => site.displayName || site.name || '--',
    disableSortBy: true
  },
  {
    Header: 'Signal Volume (Daily Avg.)',
    id: 'signalVolumeDailyAvg',
    type: 'string',
    accessor: site => site.signalVolumeDailyAvg ?? '--',
    disableSortBy: true
  },
  {
    Header: 'Match Rate',
    id: 'matchRate',
    type: 'number',
    accessor: site => site.matchRate,
    Cell: ({ value }) => (value === null || value === undefined ? '--' : `${value}%`)
  }
];

export default columns;
